const cellWidth = (width, style) => ({
  style: {
    ...style,
    minWidth: width,
    maxWidth: width,
  },
});

export { cellWidth };
